export const actionType = {
  SET_USER: "SET_USER",
  SET_PRODUCT: "SET_PRODUCT",
  SET_COMPANY: "SET_COMPANY",
  SET_SLIDER: "SET_SLIDER",
  SET_ORDERS: "SET_ORDERS",
  SET_APPLY_JOB: "SET_APPLY_JOB",
  SET_BLOG: "SET_BLOG",
  SET_ADMIN: "SET_ADMIN",
  SET_ENQUIRE: "SET_ENQUIRE",
  SET_SERVICE: "SET_SERVICE",

};

const reducer = (state, action) => {
  console.log(action);

  switch (action.type) {
    case actionType.SET_USER:
      return {
        ...state,
        user: action.user,
      };
    case actionType.SET_PRODUCT:
      return {
        ...state,
        Products: action.Products,
      };
    case actionType.SET_COMPANY:
      return {
        ...state,
        Company: action.Company,
      };
    case actionType.SET_SLIDER:
      return {
        ...state,
        Slider: action.Slider,
      };
   
    case actionType.SET_ORDERS:
      return {
        ...state,
        orders: action.orders,
      };
      case actionType.SET_APPLY_JOB:
        return {
          ...state,
          appliedJobs: action.appliedJobs, 
        };
        case actionType.SET_BLOG:
      return { ...state, Blog: action.Blog }; // ✅ Ensure Blog data is being set
      case actionType.SET_ADMIN:
        return {
          ...state,
          admin: action.admin,
        };
        case actionType.SET_ENQUIRE:
          return {
            ...state,
            enquire: action.enquire,
          };
          case actionType.SET_SERVICE:
            return {
              ...state,
              Service: action.Service,
            };
    default:
      return state;
  }
};

export default reducer;
